"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableStatusCell = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var BcDataTableStatusCell = (function () {
    function BcDataTableStatusCell() {
    }
    BcDataTableStatusCell.prototype.render = function (cell) {
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        var divStatusCell = this._getDivContainer(cell);
        newCell.appendChild(divStatusCell);
        return newCell;
    };
    BcDataTableStatusCell.prototype._getDivContainer = function (cell) {
        var divStatusSpan = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        divStatusSpan.textContent = cell.value;
        var divStatusCell = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divStatusCell.classList.add('bc-status');
        divStatusCell.appendChild(divStatusSpan);
        var statusWhitType = this._assignType(cell, divStatusCell);
        var statusWhitColor = this._assignColor(cell, statusWhitType);
        return this._assignBorder(cell, statusWhitColor);
        ;
    };
    BcDataTableStatusCell.prototype._assignType = function (cell, divStatusCell) {
        var optionsTypesStatus = {
            simple: this._createStatusTypeIconSimple,
            'icon-left': this._createStatusTypeIconLeft,
            'icon-right': this._createStatusTypeIconRight,
        };
        if (cell.status_type in optionsTypesStatus) {
            return optionsTypesStatus[cell.status_type](divStatusCell, cell.status_icon);
        }
        else {
            return this._createStatusTypeIconOnly(divStatusCell);
        }
    };
    BcDataTableStatusCell.prototype._assignColor = function (cell, divStatusCell) {
        cell.status_color
            ? divStatusCell.classList.add("bc-status-color-".concat(cell.status_color))
            : divStatusCell.classList.add("".concat(bc_data_table_constants_1.BcDataTableConstansts.CELL_STATUS_COLOR_WHITE));
        return divStatusCell;
    };
    BcDataTableStatusCell.prototype._assignBorder = function (cell, divStatusCell) {
        var optionsBordersStatus = {
            center: this._createStatusBorderCenter,
            left: this._createStatusBorderLeft,
            right: this._createStatusBorderRight,
        };
        if (cell.status_border in optionsBordersStatus) {
            return optionsBordersStatus[cell.status_border](divStatusCell);
        }
        return divStatusCell;
    };
    BcDataTableStatusCell.prototype._createStatusTypeIconOnly = function (cellStatus) {
        cellStatus.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_STATUS_TYPE_ONLY);
        return cellStatus;
    };
    BcDataTableStatusCell.prototype._createStatusTypeIconLeft = function (cellStatus, textIcon) {
        cellStatus.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_STATUS_TYPE_ICON_LEFT);
        var iElement = document.createElement(common_constants_1.BcCommonConstants.I_TAG);
        iElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        iElement.textContent = textIcon;
        cellStatus.prepend(iElement);
        return cellStatus;
    };
    BcDataTableStatusCell.prototype._createStatusTypeIconRight = function (cellStatus, textIcon) {
        cellStatus.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_STATUS_TYPE_ICON_RIGHT);
        var iElement = document.createElement(common_constants_1.BcCommonConstants.I_TAG);
        iElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        iElement.textContent = textIcon;
        cellStatus.appendChild(iElement);
        return cellStatus;
    };
    BcDataTableStatusCell.prototype._createStatusTypeIconSimple = function (cellStatus) {
        cellStatus.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_STATUS_TYPE_ICON_SIMPLE);
        return cellStatus;
    };
    BcDataTableStatusCell.prototype._createStatusBorderCenter = function (cellStatus) {
        cellStatus.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_STATUS_BORDER_CENTER);
        return cellStatus;
    };
    BcDataTableStatusCell.prototype._createStatusBorderLeft = function (cellStatus) {
        cellStatus.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_STATUS_BORDER_LEFT);
        return cellStatus;
    };
    BcDataTableStatusCell.prototype._createStatusBorderRight = function (cellStatus) {
        cellStatus.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_STATUS_BORDER_RIGHT);
        return cellStatus;
    };
    return BcDataTableStatusCell;
}());
exports.BcDataTableStatusCell = BcDataTableStatusCell;
